!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactSearch = t(require("react")) : e.ReactSearch = t(e.react);
}(window, function (e) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.t = function (e, t) {
      if (1 & t && (e = n(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        n.d(r, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return r;
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(4)();
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {
      return Object.prototype.toString.call(e).slice(8, -1);
    },
        o = function o(e) {
      return "Array" === r(e);
    },
        a = function a(e) {
      return "Object" === r(e);
    },
        i = function i(e) {
      return "String" === r(e);
    },
        c = function c(e) {
      return "Number" === r(e) && !Number.isNaN(e);
    },
        u = function u(e) {
      return "Null" === r(e) || "Undefined" === r(e);
    },
        s = function s(e) {
      return i(e) ? "" === e.trim() : o(e) ? 0 === e.length : a(e) ? 0 === Object.keys(e).length : u(e);
    };

    e.exports = {
      isArray: o,
      isObject: a,
      isString: i,
      isDate: function isDate(e) {
        return "Date" === r(e);
      },
      isRegExp: function isRegExp(e) {
        return "RegExp" === r(e);
      },
      isFunction: function isFunction(e) {
        return "Function" === r(e);
      },
      isBoolean: function isBoolean(e) {
        return "Boolean" === r(e) || i(e) && ("true" === e || "false" === e);
      },
      isNumber: c,
      isNull: u,
      isEmpty: s,
      isEmptyOrZero: function isEmptyOrZero(e) {
        return s(e) || c(e) && 0 === e;
      }
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var r = n(0),
        o = n.n(r),
        a = n(1),
        i = n.n(a),
        c = n(2),
        u = n.n(c);

    function s(e) {
      return (s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }

    function l(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    function p(e) {
      return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }

    function f(e, t) {
      return (f = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }

    function h(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }

    var d = {
      border: "1px #ddd solid",
      display: "inline-flex",
      justifyContent: "space-between",
      height: 35
    },
        y = {
      height: 33,
      width: 33,
      outline: "none",
      backgroundColor: "white",
      cursor: "pointer",
      padding: 5,
      boxSizing: "border-box",
      appearance: "none",
      border: "none",
      borderLeft: "1px #ddd solid"
    },
        b = {
      outline: "none",
      border: "none",
      fontSize: 14,
      padding: 10,
      flex: 1,
      color: "#5a5a5a",
      fontWeight: 100,
      height: 33
    },
        g = function g() {
      var e = Math.ceil(21);
      return o.a.createElement("svg", {
        version: "1.1",
        x: "0px",
        y: "0px",
        width: e,
        height: e,
        viewBox: "0 0 635 635",
        style: {
          fill: "#727272"
        }
      }, o.a.createElement("g", null, o.a.createElement("path", {
        d: "M255.108,0C119.863,0,10.204,109.66,10.204,244.904c0,135.245,109.659,244.905,244.904,244.905 c52.006,0,100.238-16.223,139.883-43.854l185.205,185.176c1.671,1.672,4.379,1.672,5.964,0.115l34.892-34.891 c1.613-1.613,1.47-4.379-0.115-5.965L438.151,407.605c38.493-43.246,61.86-100.237,61.86-162.702 C500.012,109.66,390.353,0,255.108,0z M255.108,460.996c-119.34,0-216.092-96.752-216.092-216.092 c0-119.34,96.751-216.091,216.092-216.091s216.091,96.751,216.091,216.091C471.199,364.244,374.448,460.996,255.108,460.996z"
      })));
    },
        m = function (e) {
      function t(e) {
        var n, r;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t), this, (n = !(r = p(t).call(this, e)) || "object" !== s(r) && "function" != typeof r ? h(this) : r).state = {
          value: n.props.searchText
        }, n.onChangeBound = n.onChangeBound.bind(h(h(n))), n.onEnterBound = n.onEnterBound.bind(h(h(n))), n.onSearchClick = n.onSearchClick.bind(h(h(n))), n;
      }

      var n, r;
      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), t && f(e, t);
      }(t, o.a.Component), n = t, (r = [{
        key: "componentWillReceiveProps",
        value: function value(e) {
          this.props.searchText !== e.searchText && this.setState({
            value: e.searchText
          });
        }
      }, {
        key: "onChangeBound",
        value: function value(e) {
          this.setState({
            value: e.target.value
          }), u.a.isFunction(this.props.onChange) && this.props.onChange(e.target.value, e);
        }
      }, {
        key: "onEnterBound",
        value: function value(e) {
          (13 === e.which || 13 === e.keyCode) && u.a.isFunction(this.props.onEnter) && this.props.onEnter(e.target.value, e);
        }
      }, {
        key: "onSearchClick",
        value: function value() {
          u.a.isFunction(this.props.onSearchClick) && this.props.onSearchClick(this.state.value);
        }
      }, {
        key: "render",
        value: function value() {
          var e = this.props,
              t = e.classNames,
              n = e.placeholder,
              r = "react-search-field ".concat(t);
          return o.a.createElement("div", {
            className: r,
            style: d
          }, o.a.createElement("input", {
            className: "react-search-field-input",
            style: b,
            onChange: this.onChangeBound,
            onKeyPress: this.onEnterBound,
            placeholder: n,
            type: "text",
            value: this.state.value
          }), o.a.createElement("button", {
            className: "react-search-field-button",
            type: "button",
            style: y,
            onClick: this.onSearchClick
          }, o.a.createElement(g, null)));
        }
      }]) && l(n.prototype, r), t;
    }();

    m.propTypes = {
      classNames: i.a.string,
      searchText: i.a.string,
      placeholder: i.a.string,
      onChange: i.a.func,
      onEnter: i.a.func,
      onSearchClick: i.a.func
    }, m.defaultProps = {
      classNames: "",
      searchText: "",
      placeholder: "Search",
      onChange: null,
      onEnter: null,
      onSearchClick: null
    }, t.default = m;
  }, function (e, t, n) {
    "use strict";

    var r = n(5);

    function o() {}

    e.exports = function () {
      function e(e, t, n, o, a, i) {
        if (i !== r) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = o, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }]);
});